import { render, staticRenderFns } from "./facturas.vue?vue&type=template&id=88300a26&"
import script from "./facturas.vue?vue&type=script&lang=js&"
export * from "./facturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports